/*
 * @Author: songyzh
 * @Date: 2021-05-12 18:58:32
 * @LastEditors: songyzh
 * @LastEditTime: 2021-05-12 18:59:03
 * @Description:
 */

import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;
